import { setTerms } from '@/packages/JsonQuery/helpers';

export const setGatesType = setTerms('building_gates_type');
